export function SeparatorIcon(props) {
  const { className, ...rest } = props;
  return (
    <svg className={className} {...rest} width='15' height='2' viewBox='0 0 15 2' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M0 1H15' stroke='#858899' />
    </svg>
  );
}
